import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { CellData } from './DataView';

const isObjectEmpty = (obj: CellData) => Object.values(obj).every(value => value === null || value === undefined);

export const getValueByKey = (key: string, object: Record<string, any>) => {
  let value = '';

  try {
    if (!key || !object || typeof object !== 'object') return value;

    if (isObjectEmpty(object)) return;

    const subkeys = key.split('.');

    let currentObject = object;

    for (const subkey of subkeys) {
      if (currentObject && typeof currentObject === 'object' && subkey in currentObject) {
        value = currentObject[subkey];
        currentObject = currentObject[subkey];
      } else {
        value = '';
        break;
      }
    }
  } catch (error) {
    displayErrorNotification();
  } finally {
    return value;
  }
};
